import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InitialServiceService } from './initial-service.service';
import { Router } from '@angular/router';
import {Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Title } from '@angular/platform-browser';
import initHelpHero from 'helphero';
import { ChatService } from './main/circles/chat.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent  implements OnInit {
  constructor(
    public intialService:InitialServiceService,
     private modalService: NgbModal,
     private router: Router,
     @Inject(DOCUMENT) private _document: HTMLDocument,
     private titleService: Title,
     private chatService: ChatService
     ) 
  {
    const helphero = initHelpHero('hBhCNmKxpDj');
    helphero.anonymous();
   }
  projectDetail:any;
  isLoading:boolean = false;
  userData: ""
  ngOnInit(){
  this.getProjectDetail();
 
  }
  readLocalStorageValue(key: string): string {
    return localStorage.getItem(key);
  }
  getProjectDetail() {
   let detail = this.readLocalStorageValue('userData')
    // this.userData = JSON.parse(localStorage.getItem("userData"));
    if(detail == 'undefined') {
      this.userData = ''
    } else {
      this.userData = JSON.parse(detail);
    }
    this.isLoading = true;
    this.intialService.loadProject().subscribe (
      res => {
        this.isLoading = false;
      if ((res["message"] == "Success")) {
        this.projectDetail = res.data.projectList[0];
        document.documentElement.style.setProperty('--theme_primary', this.projectDetail['primaryThemeColor']);
        localStorage.setItem("_project",this.projectDetail['_id'])

        let projecDetail= {
          "name": this.projectDetail['name'],
          "domain": this.projectDetail['domain'],
          "primaryThemeColor": this.projectDetail['primaryThemeColor'],
          "secondaryThemeColor":this.projectDetail['secondaryThemeColor'],
          "loginNavigationLink": this.projectDetail['loginNavigationLink'],  
          "homepageNavigationLink": this.projectDetail['homepageNavigationLink'],
          "icon": this.projectDetail['icon'],
          "emailIcon": this.projectDetail['emailIcon']
      }
      this.titleService.setTitle(this.projectDetail['name']);
        localStorage.setItem('full_project',JSON.stringify(projecDetail))
        localStorage.setItem('project_config',JSON.stringify(res.data.uiConfiguration))
        localStorage.setItem('project_Signup',JSON.stringify(res.data.signUpConfiguration))
        localStorage.setItem('project_name',JSON.stringify(res.data.projectName))

        var principalColor = "#5C0606"
        var coordinatorColor = "#1ba1e2"
        var researchAdminColor = "#836200"
        var admincolor = "#880ED4"
        // for use in chatting window
        var principalColorFade = "#5C06061f"
        var coordinatorColorFade = "#1ba1e21f"
        var researchAdminColorFade = "#8362001f"
        var admincolorFade = "#880ED41f"
        // for use in chatting window -- icons
        var principalColorIcon = "#5C06069f"
        var coordinatorColorIcon = "#20a1df"
        var researchAdminColorIcon = "#8362009f"
        var admincolorIcon = "#880ED49f"
        // for bell icon
        var principalColorBell = "#d86161"
        var coordinatorColorBell = "#1ba1e29f"
        var researchAdminColorBell = "#b99d4a"
        var admincolorBell = "#c05aff"
if(!this.userData) {
  document.documentElement.style.setProperty('--theme_secondary',coordinatorColor);
  document.documentElement.style.setProperty('--theme_fade',coordinatorColorFade);
  document.documentElement.style.setProperty('--theme_icon',coordinatorColorIcon);
  document.documentElement.style.setProperty('--theme_bell',coordinatorColorBell);
}
if( this.userData !== null && this.userData['tuftsRole'].length > 1) {
  document.documentElement.style.setProperty('--theme_secondary',coordinatorColor);
  document.documentElement.style.setProperty('--theme_fade',coordinatorColorFade);
  document.documentElement.style.setProperty('--theme_icon',coordinatorColorIcon);
  document.documentElement.style.setProperty('--theme_bell',coordinatorColorBell);
}
if( this.userData !== null && this.userData['tuftsRole'].length == 1 && (this.userData['tuftsRole'][0] == 'CTO'|| this.userData['tuftsRole'][0] == 'Admin' || this.userData['tuftsRole'][0] == 'CTMS Support')) {
  document.documentElement.style.setProperty('--theme_secondary',admincolor);
  document.documentElement.style.setProperty('--theme_fade',admincolorFade);
  document.documentElement.style.setProperty('--theme_icon',admincolorIcon);
  document.documentElement.style.setProperty('--theme_bell',admincolorBell);
}
if( this.userData !== null && this.userData['tuftsRole'].length == 1 && this.userData['tuftsRole'][0] == 'Principal Investigator') {
  document.documentElement.style.setProperty('--theme_secondary',principalColor);
  document.documentElement.style.setProperty('--theme_fade',principalColorFade);
  document.documentElement.style.setProperty('--theme_icon',principalColorIcon);
  document.documentElement.style.setProperty('--theme_bell',principalColorBell);
}

if(this.userData !== null && this.userData['tuftsRole'].length == 1 && this.userData['tuftsRole'][0] == 'Study Coordinator') {
  document.documentElement.style.setProperty('--theme_secondary',coordinatorColor);
  document.documentElement.style.setProperty('--theme_fade',coordinatorColorFade);
  document.documentElement.style.setProperty('--theme_icon',coordinatorColorIcon);
  document.documentElement.style.setProperty('--theme_bell',coordinatorColorBell);
}

if(this.userData !== null && this.userData['tuftsRole'].length == 1 && this.userData['tuftsRole'][0] == 'Research Admin') {
  document.documentElement.style.setProperty('--theme_secondary',researchAdminColor);
  document.documentElement.style.setProperty('--theme_fade',researchAdminColorFade);
  document.documentElement.style.setProperty('--theme_icon',researchAdminColorIcon);
  document.documentElement.style.setProperty('--theme_bell',researchAdminColorBell);
}
      } else {
        document.documentElement.style.setProperty('--theme_secondary',coordinatorColor);
        document.documentElement.style.setProperty('--theme_fade',coordinatorColorFade);
        document.documentElement.style.setProperty('--theme_icon',coordinatorColorIcon);
        document.documentElement.style.setProperty('--theme_bell',coordinatorColorBell);
      }      },
      err => {
        this.isLoading = false;
      }
    );
  }
  getUserRole() {
    this.isLoading = true;
    this.intialService.loadProject().subscribe (
      res => {
        this.isLoading = false;
      if ((res["message"] = "Success")) {
        this.projectDetail = res.data.projectList[0];
        localStorage.setItem("_project",this.projectDetail['_id'])
        document.documentElement.style.setProperty('--theme_primary', this.projectDetail['primaryThemeColor']);
        document.documentElement.style.setProperty('--theme_secondary', this.projectDetail['secondaryThemeColor']);
       

      } else {
    
      }      },
      err => {
        this.isLoading = false;
      }
    );
  }
  

}